import * as cTypes from 'config/ConfigTypes';
import { getDialogConfig } from "helpers/ConfigHelper";

export const checkAndConvertMetadata = ({ userInputs }) => {
    let changed = false;
    if (userInputs) {
        for (let i in userInputs) {
            if (typeof userInputs[i] == 'object') {
                if (userInputs[i] && userInputs[i].value) {
                    userInputs[i] = userInputs[i].value;
                    changed = true;
                }
            }
        }
        if (changed) return userInputs;
    }
    return null;
}

export const isMetaValid = ({ userInputs, entry }) => {
    if (!userInputs[entry.name]) return false;
    if (userInputs && userInputs[entry.name] && userInputs[entry.name].value
        && userInputs[entry.name].value.includes(cTypes.XX)) {
        return false;
    }
    return true;
}

export const isXX = ({ ddItem }) => {
    if (ddItem && ddItem.value && ddItem.value.includes(cTypes.XX)) {
        return true;
    }
    return false;
}

export const checkDependForDD = ({ authObjects, entry, authForm, ddItem, updateAuthObjects, setUserInputs }) => {
    if (isXX({ ddItem })) {
        if (authObjects && authObjects[entry.originalname] && authObjects[authForm]) {
            let firstObj = null;
            let changed = false;
            let newObjects = { ...authObjects[authForm] };
            if (typeof authObjects[entry.originalname] === 'object') {
                for (let first in authObjects[entry.originalname]) {
                    firstObj = authObjects[entry.originalname][first];
                    if (firstObj) break;
                }
            }
            if (typeof firstObj === 'object') {
                for (let i in firstObj) {
                    if (newObjects && newObjects[i]) {
                        changed = true;
                        newObjects[i] = '';
                    }
                }
            }
            if (changed) {
                updateAuthObjects({ [`${authForm}`]: { ...newObjects, [entry.name]: ddItem } });
                setUserInputs({ ...newObjects });
            }
            return true;
        }
    }
    return false;
}

export const clearEmpty = ({ nUserInputs }) => {
    if (nUserInputs[cTypes.USER_INST]) {
        for (let fi in nUserInputs) {
            if (nUserInputs[fi] === "" || fi == cTypes.ID
                || parseInt(nUserInputs[fi]) == 0
            ) {
                delete nUserInputs[fi];
            }
        }
    }
    return nUserInputs;
}

export const checkReadOnly = ({ data, fi, dm }) => {
    if (fi && fi.params && fi.params[dm]
        &&
        ((fi.params[dm].type && fi.params[dm].type == cTypes.READONLY)
            || fi.params[dm][cTypes.NOT_SEND]
        )
    ) {
        if (data[fi.field]) data[fi.field] = '';
    }

    return data;
}

export const checkAndClearInputs = ({ userInputs, configObjects }) => {
    let dm = cTypes.REGISTER_INST;
    let fields = getDialogConfig({
        dialogMode: dm,
        configObjects, configName: "instconfig"
    });
    let nUserInputs = { ...userInputs };
    if (fields && fields.length) {
        fields.forEach(fi => {
            nUserInputs = checkReadOnly({ data: nUserInputs, fi, dm });
            if (fi.children && fi.children.length) {
                fi.children.forEach(child => {
                    nUserInputs = checkReadOnly({ data: nUserInputs, fi: child, dm });
                })
            }
        })
    }

    nUserInputs = clearEmpty({ nUserInputs });
    return nUserInputs;
}